import { openBlock as o, createElementBlock as t, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(a, e) {
  return o(), t("svg", n, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M12 3.5a.5.5 0 0 1 0 1H4.5v15H12a.5.5 0 0 1 0 1H3.5v-17z"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M16.647 9.146a.5.5 0 0 1 .707 0l3.353 3.354-3.354 3.354a.5.5 0 1 1-.707-.707L18.793 13H11a.5.5 0 0 1 0-1h7.793l-2.146-2.146a.5.5 0 0 1 0-.708"
    }, null, -1)
  ])]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
